$.fn.DelegateAccount = function() {
    var self = this;
    self.form = self.find('#delegate-form');
    if (self.form.length) {
        self.form.Form();
    }

    self.clearForm = function() {
        self.form.get(0).reset();
        self.form.find('input[name=id]').val('');
        self.form.find('input[name=action]').val('add');
        self.form.find('button.btn-delegate-submit span').text('save');
        self.form.find('button.btn-delegate-submit')[0].lastChild.nodeValue = 'Créer le compte';
        self.form.find('.delegate-form-title').text('Nouvel accès délégué');
        self.form.find('.btn-delegate-cancel').addClass('d-none');
        self.form.find('label[for="field-user-password"], label[for="field-user-password-repeat"]').addClass('mandatory');
        return false;
    };

    self.fillForm = function(row) {
        self.form.find('input[name=action]').val('edit');
        self.form.find('input[name=id]').val(row.data('id'));
        self.form.find('input[name=firstname]').val(row.data('firstname'));
        self.form.find('input[name=lastname]').val(row.data('lastname'));
        self.form.find('input[name=email]').val(row.data('email'));
        self.form.find('input[name="user-password"]').val('');
        self.form.find('input[name="user-password-repeat"]').val('');
        self.form.find('label[for="field-user-password"], label[for="field-user-password-repeat"]').removeClass('mandatory');
        self.form.find('.delegate-form-title').text("Modifier l'accès délégué");
        self.form.find('button.btn-delegate-submit span').text('save');
        self.form.find('button.btn-delegate-submit')[0].lastChild.nodeValue = 'Mettre à jour';
        self.form.find('.btn-delegate-cancel').removeClass('d-none');
        return false;
    };

    self.editClicked = function(e) {
        e.preventDefault();
        var row = $(this).closest('tr');
        self.fillForm(row);
    };

    self.deleteClicked = function(e) {
        e.preventDefault();
        var row = $(this).closest('tr');
        var id = row.data('id');
        swal({
            title: "Suppression d'un compte",
            text: "Êtes-vous certain de vouloir supprimer ce compte?",
            type: "warning",
            showCancelButton: true,
            confirmButtonClass: "btn-danger",
            confirmButtonText: 'Supprimer',
            cancelButtonText: 'Annuler',
            closeOnConfirm: true
        }, function(isConfirm) {
            if (isConfirm) {
                var request = new FormData();
                request.append('model', 'accountant');
                request.append('action', 'delete');
                request.append('id', id);
                request.append('data', JSON.stringify({}));
                $.slr.db.add(request);
            }
        });
        return false;
    };

    return function() {
        $(document).on('click', '#delegate-module .btn-edit-delegate', self.editClicked);
        $(document).on('click', '#delegate-module .btn-delete-delegate', self.deleteClicked);
        self.form.on('click', '.btn-delegate-cancel', self.clearForm);
        return self;
    }();
};

